import React from 'react';

import * as S from './styles';
import { DataFormProps, BannerProps } from 'types/InputsGridOfBannersProps';

interface DefaultProps {
	bannersData: DataFormProps;
}

export default function Default({ bannersData }: DefaultProps) {
	function returnGrid(banners: BannerProps[]) {
		switch (bannersData.typeGridBanners) {
			case 0:
				return (
					<S.dubleBanner>
						{banners.map((banner) => (
							<S.img
								key={banner.file_id}
								src={banner.file_path}
								alt={banner.file_id}
							/>
						))}
					</S.dubleBanner>
				);

			case 1:
				return (
					<S.tripleBanner>
						{banners.map((banner) => (
							<S.img
								key={banner.file_id}
								src={banner.file_path}
								alt={banner.file_id}
							/>
						))}
					</S.tripleBanner>
				);

			case 2:
				return (
					<S.tripleBannersLeftOrRight>
						<S.twoBannersColumn>
							<S.img
								key={bannersData?.banners[0]?.file_id}
								src={bannersData?.banners[0]?.file_path}
								alt={bannersData?.banners[0]?.file_id}
							/>
							<S.img
								key={bannersData?.banners[1]?.file_id}
								src={bannersData?.banners[1]?.file_path}
								alt={bannersData?.banners[1]?.file_id}
							/>
						</S.twoBannersColumn>
						<S.img
							key={bannersData?.banners[2]?.file_id}
							src={bannersData?.banners[2]?.file_path}
							alt={bannersData?.banners[2]?.file_id}
						/>
					</S.tripleBannersLeftOrRight>
				);

			case 3:
				return (
					<S.tripleBannersLeftOrRight>
						<S.img
							key={bannersData?.banners[0]?.file_id}
							src={bannersData?.banners[0]?.file_path}
							alt={bannersData?.banners[0]?.file_id}
						/>
						<S.twoBannersColumn>
							<S.img
								key={bannersData?.banners[1]?.file_id}
								src={bannersData?.banners[1]?.file_path}
								alt={bannersData?.banners[1]?.file_id}
							/>
							<S.img
								key={bannersData?.banners[2]?.file_id}
								src={bannersData?.banners[2]?.file_path}
								alt={bannersData?.banners[2]?.file_id}
							/>
						</S.twoBannersColumn>
					</S.tripleBannersLeftOrRight>
				);

			case 4:
				return (
					<S.twoBannersColumn>
						{banners.map((banner) => (
							<S.img
								key={banner.file_id}
								src={banner.file_path}
								alt={banner.file_id}
							/>
						))}
					</S.twoBannersColumn>
				);

			case 5:
				return (
					<S.mosaic4Banners>
						<S.img
							key={bannersData?.banners[0]?.file_id}
							src={bannersData?.banners[0]?.file_path}
							alt={bannersData?.banners[0]?.file_id}
						/>

						<div>
							<S.img
								key={bannersData?.banners[1]?.file_id}
								src={bannersData?.banners[1]?.file_path}
								alt={bannersData?.banners[1]?.file_id}
							/>
							<S.img
								key={bannersData?.banners[2]?.file_id}
								src={bannersData?.banners[2]?.file_path}
								alt={bannersData?.banners[2]?.file_id}
							/>
						</div>

						<S.img
							key={bannersData?.banners[3]?.file_id}
							src={bannersData?.banners[3]?.file_path}
							alt={bannersData?.banners[3]?.file_id}
						/>
					</S.mosaic4Banners>
				);

			case 6:
				return (
					<S.mosaic3Banners>
						<div>
							<S.img
								key={bannersData?.banners[0]?.file_id}
								src={bannersData?.banners[0]?.file_path}
								alt={bannersData?.banners[0]?.file_id}
							/>

							<S.img
								key={bannersData?.banners[1]?.file_id}
								src={bannersData?.banners[1]?.file_path}
								alt={bannersData?.banners[1]?.file_id}
							/>
						</div>
						<S.img
							key={bannersData?.banners[2]?.file_id}
							src={bannersData?.banners[2]?.file_path}
							alt={bannersData?.banners[2]?.file_id}
						/>
					</S.mosaic3Banners>
				);

			default:
				return (
					<S.noGrid>
						<p>Tipo de grid não esperada</p>
					</S.noGrid>
				);
		}
	}

	return <S.container>{returnGrid(bannersData.banners)}</S.container>;
}
